import * as React from 'react'
import { IStageProps } from 'app/types'
import Clock from 'app/comp/clock'
import Hint from 'app/comp/hint'
import StageCounter from 'app/comp/stage-counter'
import DocumentEventHandler from 'app/comp/document-event-handler'
import * as Sound from 'app/service/sound'


const LINES = [
  'look up for heavenly inspiration',
  'look back to learn from the past',
  'and forward to find your future. '
]


export default class TypeoutStage extends React.Component<IStageProps, {
  row: number
  col: number
}> {

  constructor(props) {
    super(props)

    this.state = {
      row: 0,
      col: 0
    }
  }

  handleKeyPress = event => {
    const { row, col } = this.state

    const keyCode = event.which

    if (row == 0) {
      this.advance()
    } else if (row == 1) {
      const aboveKeyCode = LINES[row - 1][col].charCodeAt(0)
      if (keyCode == aboveKeyCode) {
        this.advance()
      }
    } else if (row == 2) {
      if (col == 0) {
        this.advance()
      } else {
        const previousKeyCode = LINES[row][col - 1].charCodeAt(0)
        if (keyCode == previousKeyCode) {
          this.advance()
        }
      }
    }

  }

  advance() {
    const { row, col } = this.state

    if (col >= LINES[row].length - 1) {
      if (row == 2) {
        this.props.onNext()
      } else {
        Sound.playRiff(row)
        this.setState({row: row + 1, col: 0})
      }
    } else {
      this.setState({col: col + 1})
    }
  }

  getLines() {
    const { row, col } = this.state

    const lines: string[] = []

    for (let i = 0; i < LINES.length; i++) {
      if (i < row) {
        lines.push(LINES[i])
      } else if (i == row) {
        lines.push(LINES[i].slice(0, col))
      }
    }

    return lines
  }

  getHintText(): string {
    const { row } = this.state

    if (row == 0) {
      return "I should write what's on my mind."
    } else if (row == 1) {
      return "I see a message above. Maybe I should copy that."
    } else {
      return "Back? Like to the left? Oh. I can type what I see to the left."
    }
  }

  renderCursor() {
    const {
      col,
      row
    } = this.state

    return (
      <div
        style={{
          height: 26,
          width: 2,
          backgroundColor: 'black',
          position: 'absolute',
          top: row * 26,
          left: col * 12
        }}
      />
    )
  }

  render() {
    return (
      <div>

        <DocumentEventHandler
          onKeyPress={this.handleKeyPress}
        />

        <Hint
          onAddTime={this.props.onAddTime}
          delay={1 * 60 * 1000}
          text={this.getHintText()}
        />

        <StageCounter info={this.props.stageInfo} />

        <Clock time={this.props.time} />

        <div style={{position: 'relative', width: 384, height: 54, fontSize: 24}}>
          {this.getLines().map((line, i) =>
            <div key={i}>{line}</div>
          )}

          {this.renderCursor()}
        </div>

      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/stage/typeout.tsx